import { useEffect, useRef } from "react";
import { CHANNELS } from "@common";
import type { ChannelType } from "@interfaces/chat.interface";

type Page = { id: string; name: string };

type Params = {
  facebookPages: Page[];
  fanpagesLoading: boolean;
  selectedFanpageName?: string;
  selectedPageId?: string;
  selectedChannel: string;
  selectFanpage: (fanpageName: string, pageId: string, channelType: ChannelType) => void;
  locationPathname: string;
};

export const useFirstFacebookPageSelect = ({
  facebookPages,
  fanpagesLoading,
  selectedFanpageName,
  selectedPageId,
  selectedChannel,
  selectFanpage,
  locationPathname,
}: Params) => {
  const hasSelectedRef = useRef(false);

  useEffect(() => {
    if (hasSelectedRef.current) return;
    if (fanpagesLoading) return;
    if (locationPathname.startsWith("/settings")) return;
    if (selectedFanpageName || selectedPageId) return;
    if (selectedChannel !== CHANNELS.FACEBOOK) return;
    if (facebookPages.length === 0) return;

    const firstPage = facebookPages[0];
    hasSelectedRef.current = true;
    selectFanpage(firstPage.name, firstPage.id, CHANNELS.FACEBOOK);
  }, [
    facebookPages,
    fanpagesLoading,
    selectedFanpageName,
    selectedPageId,
    selectedChannel,
    selectFanpage,
    locationPathname,
  ]);
};
